/*
 * WHY A BINDING WAS LEFT OUT, IN THE READER'S LANGUAGE.
 *
 * The driver carries an English sentence for each input it set aside — that is
 * what the assistant reads — and the fields the sentence was made from. A
 * person's view says it again from those fields, so the reason sits in the same
 * language as the heading and the hint around it. One function, so the
 * Simulate panel's list, the search's notes and the viewer's picker agree.
 */
import { getLocale, t } from '@vitesse/base-ui/i18n';
import type { SkippedInput } from '../../../sandbox/statechart/replay';
import { formatMoment } from './statechart-replay-model';

export function skippedReason(s: SkippedInput): string {
  switch (s.why) {
    case 'integration-path':
      return t('model.replaySkipIntegration', { path: s.path });
    case 'not-a-path':
      return t('model.replaySkipNotPath', { path: s.path });
    case 'no-history':
      return t('model.replaySkipNoHistory', { scope: s.scope });
    case 'window-after':
      return t('model.replaySkipWindowAfter', { scope: s.scope, when: formatMoment(s.atMs, getLocale(), { date: true }) });
    case 'window-before':
      return t('model.replaySkipWindowBefore', { scope: s.scope, when: formatMoment(s.atMs, getLocale(), { date: true }) });
  }
}
